<!-- 
	图片导航 Z02
	1、图片导航样式：图片导航、文字导航
	2、滑动设置：固定，横向滚动
	3、背景颜色
	4、文字颜色
	5、字号
	6、文本位置 底部 中部
	7、背景图片上传
	注：横向滚动未实现
-->
<template>
	<view :style="wrapperStyle">
		<view v-if="data.slideType == 1" :border="false" class="swiper-container" style="margin-right: 2px;">
			<view v-for="(item,index) in list" :key="index" class="swiper-item" @click="navigateTo(item)">
				<view :style="panelStyle" class="swiper-block">
					<image v-if="data.navigationType == 1" :src="getImageUrl(item.rollpicUrl)" mode="widthFix"></image>
					<text class="swiper-text" :style="fontStyle">{{item.picTitle}}</text>
				</view>
			</view>
		</view>
		<up-scroll-list v-if="data.slideType == 2" :indicator="false">
			<view v-for="(item, index) in list" :style="panelStyle" :key="index" class="swiper-wrapper f_c_c_c" @click="navigateTo(item)">
				<image v-if="data.navigationType == 1" :src="getImageUrl(item.rollpicUrl)" mode="widthFix" class="swiper-image"></image>
				<text class="swiper-text" :style="fontStyle" style="min-width:140rpx;">{{item.picTitle}}</text>
			</view>
		</up-scroll-list>
	</view>
</template>
<!--
"decorateNavigationBo": {
	"id": "49c4fc45740711f0a3479c5c8ebcfe65",
	"companyId": "1",
	"shopId": "1",
	"decorateId": "ad0507d26f9f11f0a3479c5c8ebcfe65",
	"decorateModuleId": "49c3dd1a740711f0a3479c5c8ebcfe65",
	"navigationType": 1,
	"slideType": 1,
	"backgroundColor": "#ffffff",
	"textColor": "#999999",
	"createTime": "2025-08-08 11:25:10",
	"titlePosition": 1,
	"textFontSize": 16,
	"decorateNavigationDetailList": [{
		"id": "49c5d5b7740711f0a3479c5c8ebcfe65",
		"companyId": "1",
		"shopId": "1",
		"decorateModuleId": "49c3dd1a740711f0a3479c5c8ebcfe65",
		"decorateNavigationId": "49c4fc45740711f0a3479c5c8ebcfe65",
		"rollpicUrl": "image/2025-08-05/9433a21ffefd48aca9f704a4ce863a02.png",
		"sort": 0,
		"picTitle": "医美",
		"createTime": "2025-08-08 11:25:10",
		"lastHeight": 52.00,
		"lastWidth": 52.00,
		"realWidth": 67.00,
		"realHeight": 67.00
	}]
}
-->

<script setup>
	import {fnImgRequestPath} from "@/utils/utils";
	import { getCurrentInstance, reactive, ref, computed} from "vue";
	const { ctx } = getCurrentInstance(); //获取上下文实例，ctx=vue2的this
	const props = defineProps({
		componentId: {
			type: String,
			default: ''
		},
		data: {
			type: Object,
			default () {
				return {
					//图片导航样式：图片导航 1、文字导航 2
					"navigationType": {
						type: Number,
						default: 1
					},
					//滑动设置：1固定，2横向滚动
					"slideType": {
						type: Number,
						default: 1
					},
					//背景颜色
					"backgroundColor": {
						type: String,
						default: '"#ffffff'
					},
					//背景图片
					"backgroundUrl": {
						type: String,
						default: ''
					},
					//字体颜色
					"textColor": {
						type: String,
						default: '"#999999'
					},
					//字体颜色
					"textColor": {
						type: String,
						default: '"#999999'
					},
					//字体位置
					"titlePosition": {
						type: Number,
						default: 1
					},
					//字体大小
					"textFontSize": {
						type: Number,
						default: 12
					}
				}
			}
		}
	})
	
	/**
	 * 组件样式
	 */
	const wrapperStyle = computed(() => {
		if (props.data.decorateNavigationDetailList) {
			const {
				backgroundColor,
				backgroundUrl
			} = props.data;
			return `
				background-color: ${backgroundColor};
				background-image: url(${backgroundUrl ? getImageUrl(backgroundUrl) : ''});
				background-repeat: repeat;
				background-size: 100% 100%;
				bakcground-position: center;
			`;
		}
	})
	
	/**
	 * 显示块样式
	 */
	const panelStyle = computed(() => {
		const {
			navigationType
		} = props.data;
		if(navigationType == 1){
			return `
				height: auto;
				margin-top: 5px;
			`;
		}else{
			return `
				height: 60rpx;
				display: -webkit-flex;
				display: flex;
				-webkit-flex-direction:row;
				flex-direction: row;
				-webkit-align-items:center;
				align-items: center;
				-webkit-justify-content: center;
				justify-content: center;
			`;
		}
	})
	
	/**
	 * 字体样式
	 */
	const fontStyle = computed(() => {
		const {
			textColor,
			textFontSize
		} = props.data;
		return `
			color: ${textColor};
			font-size: ${textFontSize}px;
		`;
	});
	
	/**
	 * 数据处理
	 */
	const list = computed(() => {
		if (props.data.decorateNavigationDetailList != null && props.data.decorateNavigationDetailList != undefined && props.data.decorateNavigationDetailList.length > 0) {
			return props.data.decorateNavigationDetailList;
		}
		return [];
	});
	
	/**
	 * 页面跳转方法
	 * @param {Object} item
	 */
	function navigateTo(item) {
		let decorateLinkBo = item.decorateLinkBo
		let linkType = item.decorateLinkBo.linkType
		// console.log("item:", linkType, decorateLinkBo)
		
		// 微页面
		if (linkType == 1) {
			uni.navigateTo({
				url: '/pages/microPage/microPage?activityId=' + item.decorateLinkBo.activityId
			})
		}
		// 商品详情
		else if (linkType == 2 || linkType == 13) {
			uni.navigateTo({
				url: '/pages/prodDetail/detail?prodId=' + decorateLinkBo.prodId,
			})
		}
		// 公众号文章
		else if (linkType == 5) {
			/* uni.navigateTo({
				url: `/pages/webview/webview?url=${encodeURIComponent(decorateLinkBo.linkUrl)}`
			}) */
			const url = decorateLinkBo.linkUrl;
			if (!url) {
				uni.showToast({
					title: '链接无效',
					icon: 'none'
				});
				return;
			}
			
			// 模拟跳转延迟（实际中可去掉）
			setTimeout(() => {
				// 尝试跳转
				if (typeof plus !== 'undefined') {
					console.log("1")
					plus.runtime.openWeb(url, (error) => {
						// 跳转失败（如未安装抖音）
						console.error('跳转失败:', error);
						uni.showToast({
							title: '应用未安装',
							icon: 'none',
							duration: 500
						});
						// 此时用户可手动点击左上角返回
					});
				} else {
					console.log("2")
					// H5 环境
					window.open(url, '_blank');
					// H5 中无法判断是否打开成功，用户可自行返回
				}
				
			}, 800); // 给用户一点“正在跳转”的视觉反馈
		}
		// 商品分类
		else if (linkType == 3) {
			let prodClassId = decorateLinkBo.prodClassId
			uni.setStorageSync("prodClassId", prodClassId)
			uni.navigateTo({
				url: '/pages/prodList/prodList?inSource=004&isClassType=1'
			})
		}
	}
	
	/**
	 * 获取图片地址
	 */
	function getImageUrl(imgUrl){
		return fnImgRequestPath(imgUrl);
	}
	
</script>

<style lang="less" scoped>
	.swiper-container{
		display:flex;
	}
	
	.swiper-item{
		flex-grow: 1;
	}
	
	.swiper-block{
		display:flex;
		flex-flow: column; //垂直排列
		justify-content: space-between;//两端对齐
	}

	.swiper-wrapper{
		display:flex;
		flex-flow: column; //垂直排列
		justify-content: space-between;//两端对齐
	}
	.swiper-image {
		width: 120rpx;
		height: 120rpx;
	}

	.swiper-text {
		margin: 5px 0 5rpx 0rpx;
		width: 100%;
		text-align: center;
	}
	
	::v-deep .u-scroll-list {
		padding-bottom: 0px !important
	}
</style>
